// extracted by mini-css-extract-plugin
export default {"arrow":"arrowButton-module__arrow--NDOUW","left":"arrowButton-module__left--Tcxa2","right":"arrowButton-module__right--zcNH_"};